import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const ChamberOfCommerceMonthlyLuncheon = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Miami Lakes Chamber of Commerce Monthly Luncheon – 9/10/25
      </Typography>

      <Typography paragraph>
        On Wednesday, September 10, the Town of Miami Lakes joined local business leaders at the Miami Lakes
        Chamber of Commerce Monthly Luncheon to present its Vision Zero initiative: a commitment to eliminating
        traffic-related fatalities and serious injuries within the community.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-luncheon-event2.jpg`}
        alt="Members of the Chamber of Commerce filling out the Public Input Survey"
        sx={{ width: '100%',maxHeight: 750, borderRadius: 2, mb: 1 }}
      />
      <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', mb: 3 }}>
        Members of the Chamber of Commerce filling out the Public Input Survey
      </Typography>

      <Typography paragraph>
        The presentation highlighted the Town’s multi-pronged approach, focusing on education, infrastructure, and
        other strategies designed to create safer streets for all users. Chamber members learned how Vision Zero
        aligns with the Town’s long-term transportation goals and why local businesses play a critical role in
        shaping a safer and more connected Miami Lakes.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-luncheon-event3.jpg`}
        alt="Project Manager Jesús Fuentes presenting to the Chamber of Commerce"
        sx={{ width: '100%', borderRadius: 2, mb: 3 }}
      />
      <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', mb: 3 }}>
        Project Manager Jesús Fuentes presenting to the Chamber of Commerce
      </Typography>

      <Typography paragraph>
        The Vision Zero team engaged directly with attendees, answering questions about implementation, speeding
        concerns, and opportunities for collaboration. The discussion sparked meaningful dialogue on how businesses
        can support safer mobility through employee engagement, and shared resources.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-luncheon-event4.jpg`}
        alt="Project Manager Jesús Fuentes answering questions from members of the Chamber"
        sx={{ width: '100%', borderRadius: 2, mb: 1 }}
      />
      <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', mb: 3 }}>
        Project Manager Jesús Fuentes answering questions from members of the Chamber
      </Typography>

      <Typography paragraph>
        In addition to the presentation, the Town collected over 20 public surveys, providing valuable insights into
        community priorities. This continuous feedback will help guide future planning efforts and ensure that Vision
        Zero reflects the needs of residents, businesses, and visitors alike.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-luncheon-event5.jpg`}
        alt="Discussion of Vision Zero’s community efforts with a member of the Chamber"
        sx={{ width: '100%', borderRadius: 2, mb: 1 }}
      />
      <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', mb: 3 }}>
        Discussion of Vision Zero’s community efforts with a member of the Chamber
      </Typography>

      <Typography variant="h5" gutterBottom>
        Next Event: Let’s Take the Bus, Miami Lakes!
      </Typography>

      <Typography paragraph>
        The Town’s next outreach event, Let’s Take the Bus, Miami Lakes!, will take place on Monday, September 15
        at 10:00 AM meeting at Veteran’s Park.
      </Typography>

      <Typography paragraph>
        This free, interactive event will showcase the Town’s bus service and Freebee on-demand rides, giving a
        hands-on opportunity to explore transit options in the town and learn about routes and schedules, and share
        feedback to improve connectivity.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-luncheon-event6.jpg`}
        alt="Map of the Route for the Let’s Take the Bus, Miami Lakes! Event on 9/15/25"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />
      <Typography variant="body2" align="center" sx={{ fontStyle: 'italic', mb: 3 }}>
        Map of the Route for the Let’s Take the Bus, Miami Lakes! Event on 9/15/25
      </Typography>

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join the conversation
        through our social media channels.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstagramIcon color="action" />
          <Link
            href="https://www.instagram.com/miamilakesvisionzero"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvisionzero
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <XIcon color="action" />
          <Link
            href="https://twitter.com/miamilakesvz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvz
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon color="action" />
          <Link
            href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            Vision Zero Miami Lakes
          </Link>
        </Box>
      </Box>

      <Typography paragraph>
        Be part of the conversation and participate by completing the community survey using{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          this survey link
        </Link>
        .
      </Typography>

      <Typography paragraph>
        Our website and social media channel continue posting project updates and upcoming events.
      </Typography>

      <Typography paragraph>
        Para español:{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          haga clic aquí
        </Link>{' '}
        (seleccione español)
      </Typography>
    </Box>
  );
};

export default ChamberOfCommerceMonthlyLuncheon;
